import type { ImperativePanelHandle } from "react-resizable-panels";

import { type RefObject, useLayoutEffect } from "react";

interface UsePanelResizeProps {
    panelRef: RefObject<ImperativePanelHandle | null>;
    size: number;
    dependencies?: unknown[];
}

export const usePanelResize = ({ panelRef, size, dependencies = [] }: UsePanelResizeProps) => {
    useLayoutEffect(() => {
        try {
            panelRef.current?.resize(size);
        } catch (error) {
            console.error("Error resizing panel:", error);
        }
        // Special case here where I need to have dynamic dependencies and spread them
        // oxlint-disable-next-line exhaustive-deps
    }, [size, panelRef, ...dependencies]);
};
